import React from 'react'
import { useSelector } from '~/store/hooks'

import { Link } from 'gatsby'

import trads from '~/intl/trads.json'

import LinkIcon from '~/components/core/linkIcon'
import Image from '~/components/core/Image'

import transformLink from '~/utils/transformLink'

const ActionCard = ({ action }) => {
  const lang = useSelector((state) => state.lang)
  const { url } = transformLink(action, false, true, true)
  const { mainImage, date, title, mainTag } = action

  return (
    <Link to={url} className="action-card card card--short-picture">
      {mainImage ? (
        <div className="card__bg relative action-card__bg card__bg--short-picture">
          <Image
            image={mainImage}
            width="325"
            height="208"
            sizes={{ 415: [350, 224], 767: [707, 450], 1023: [300, 192] }}
            isBg={true}
          />
        </div>
      ) : (
        <div className="card__bg news-card__bg card__bg--empty card__bg--short-picture"></div>
      )}
      <div className="card__content news-card__content card__content--full">
        <span className="block text-label text-brick mb-2">{date}</span>
        <span className="text-label text-label--bg text-white bg-brick card__tag">
          {mainTag.title ? mainTag.title : action.mainTag}
        </span>
        <h3 className="title-3-bold title-3-bold--small mb-8">{title}</h3>
        <LinkIcon text={trads[lang].learnMore} />
      </div>
    </Link>
  )
}

export default ActionCard
